const t = {
  crop: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    unit: "%"
  }
};
export {
  t as initialState
};
